/**
 * 股东分红记录
 */
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>分红记录</el-breadcrumb-item>
    </el-breadcrumb>

    <!-- 股东累计分红汇总 -->
    <el-row :gutter="20" class="summary-row">
      <el-col :span="6" v-for="item in summaryList" :key="item.shareholderId">
        <el-card shadow="hover">
          <div class="summary-name">{{item.shareholderName}}</div>
          <div class="summary-amount">￥{{item.totalAmount}}</div>
          <div class="summary-label">累计分红</div>
        </el-card>
      </el-col>
    </el-row>

    <el-form :inline="true" class="user-search">
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-plus" v-if="$canManage()" @click="handleDistribute">发起分红</el-button>
      </el-form-item>
    </el-form>

    <!--列表-->
    <el-table size="small" :data="listData" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;">
      <el-table-column prop="occurrenceTime" label="分红日期" width="150">
        <template slot-scope="scope">
          <div>{{scope.row.occurrenceTime|formatDate}}</div>
        </template>
      </el-table-column>
      <el-table-column prop="shareholderName" label="股东" width="120">
      </el-table-column>
      <el-table-column prop="amount" label="本次分得" width="120">
      </el-table-column>
      <el-table-column prop="totalAmount" label="本次分红总额" width="140">
      </el-table-column>
      <el-table-column prop="notes" label="备注" show-overflow-tooltip>
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>

    <!-- 发起分红弹窗 -->
    <el-dialog title="发起分红" :visible.sync="distributeFormVisible" width="30%">
      <el-form label-width="100px" :model="distributeForm" :rules="distributeFormRules" ref="distributeForm">
        <el-form-item label="分红总额" prop="totalAmount">
          <el-input size="small" v-model="distributeForm.totalAmount" placeholder="请输入分红总额"></el-input>
        </el-form-item>
        <el-form-item label="分红日期" prop="occurrenceTime">
          <el-date-picker
            size="small"
            style="width: 100%"
            v-model="distributeForm.occurrenceTime"
            type="date"
            value-format="yyyy-MM-dd"
            placeholder="选择日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="备注">
          <el-input size="small" v-model="distributeForm.notes" placeholder="请输入备注"></el-input>
        </el-form-item>
        <el-form-item label="">
          <span style="color: #999; font-size: 12px;">系统会按当前所有在用股东（共{{activeShareHolderCount}}人）平均拆分</span>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="distributeFormVisible = false">取消</el-button>
        <el-button size="small" type="primary" :loading="loading" @click="submitDistribute">确认分红</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Pagination from '../../components/Pagination'
import { dividendDistribute, dividendRecordPage, dividendSummary } from '../../api/shareholderMG'
import { shareHolderList } from '../../api/shareholderMG'
export default {
  data() {
    return {
      loading: false,
      distributeFormVisible: false,
      summaryList: [],
      activeShareHolderCount: 0,
      distributeForm: {
        totalAmount: '',
        occurrenceTime: '',
        notes: ''
      },
      distributeFormRules: {
        totalAmount: [{ required: true, message: '请输入分红总额', trigger: 'blur' }],
        occurrenceTime: [{ required: true, message: '请选择分红日期', trigger: 'change' }]
      },
      formInline: {
        current: 1,
        size: 10
      },
      listData: [],
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10
      }
    }
  },
  filters: {
    formatDate(timestamp) {
      if (!timestamp) return '-'
      const dateObj = new Date(timestamp)
      const year = dateObj.getFullYear()
      const month = ('0' + (dateObj.getMonth() + 1)).slice(-2)
      const day = ('0' + dateObj.getDate()).slice(-2)
      return `${year}-${month}-${day}`
    }
  },
  created() {
    this.getdata()
    this.getSummary()
    this.getActiveShareHolderCount()
  },
  methods: {
    getdata() {
      this.loading = true
      dividendRecordPage(this.formInline)
        .then(res => {
          this.loading = false
          if (res.code !== '200') {
            this.$message({ type: 'info', message: res.message })
          } else {
            this.listData = res.data.content
            this.pageparm.currentPage = this.formInline.current
            this.pageparm.pageSize = this.formInline.size
            this.pageparm.total = res.data.total
          }
        })
        .catch(() => {
          this.loading = false
          this.$message.error('分红记录加载失败，请稍后再试！')
        })
    },
    getSummary() {
      dividendSummary()
        .then(res => {
          if (res.code === '200') {
            this.summaryList = res.data
          }
        })
    },
    getActiveShareHolderCount() {
      shareHolderList()
        .then(res => {
          if (res.code === '200') {
            this.activeShareHolderCount = res.data.filter(item => item.status === 1).length
          }
        })
    },
    callFather(parm) {
      this.formInline.current = parm.currentPage
      this.formInline.size = parm.pageSize
      this.getdata()
    },
    handleDistribute() {
      this.distributeForm.totalAmount = ''
      this.distributeForm.occurrenceTime = this.$options.filters.formatDate(new Date())
      this.distributeForm.notes = ''
      this.distributeFormVisible = true
    },
    submitDistribute() {
      this.$refs.distributeForm.validate(valid => {
        if (!valid) return false
        this.$confirm(`确定要按${this.activeShareHolderCount}位在用股东平分￥${this.distributeForm.totalAmount}吗？`, '确认分红', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.loading = true
          dividendDistribute(this.distributeForm)
            .then(res => {
              this.loading = false
              this.distributeFormVisible = false
              if (res.code === '200') {
                this.$message({ type: 'success', message: '分红成功！' })
                this.getdata()
                this.getSummary()
              } else {
                this.$message({ type: 'info', message: res.message })
              }
            })
            .catch(() => {
              this.loading = false
              this.distributeFormVisible = false
              this.$message.error('分红失败，请稍后再试！')
            })
        }).catch(() => {})
      })
    }
  }
}
</script>

<style scoped>
.user-search {
  margin-top: 20px;
}
.summary-row {
  margin-top: 20px;
}
.summary-name {
  font-size: 14px;
  color: #666;
}
.summary-amount {
  font-size: 22px;
  font-weight: bold;
  margin: 8px 0;
}
.summary-label {
  font-size: 12px;
  color: #999;
}
</style>



// WEBPACK FOOTER //
// src/views/shareholder/Dividend.vue